const PROD_ENVIRONMENT_SUFFIX = '-prod';
const SENTRY_TRACES_SAMPLE_RATE = 0.05;
export const SENTRY_ENABLED_ENVIROMENTS = ['mx-prod', 'pl-prod', 'eur-prod', 'global-prod', 'mx-preview', 'pl-preview', 'pl-staging', 'mx-staging', 'global-staging'];
export const isSentryEnvironmentEnabled = (environment: string): boolean => Boolean(environment) && SENTRY_ENABLED_ENVIROMENTS.includes(environment);
export const isSentryLoggingEnabled = (loggingEnabled: string | undefined): boolean => loggingEnabled === 'true';
export const getSentryTracesSampleRate = (environment: string): number => environment.endsWith(PROD_ENVIRONMENT_SUFFIX) ? SENTRY_TRACES_SAMPLE_RATE : 0;
export const parseSentryIgnoreErrors = (ignoreErrorsConfig: string): string[] => {
  if (!ignoreErrorsConfig) {
    return [];
  }
  return ignoreErrorsConfig.split(/[,|]/).map(error => error.trim()).filter(error => error.length > 0);
};